// Centralise les chemins pour éviter les divergences.
export const PATHS = {
  root: "/",
  authCallback: "/auth/callback",
  verifyEmail: "/verify-email",
  public: {
    clientHome: "/client/accueil",
    vitrine: "/vitrine/:id",
  },
  client: {
    home: "/client/accueil",
    vitrine: "/vitrine/:id",
    commandes: "/client/commandes",
    profil: "/client/profil",
    checkout: "/client/Checkout",
    messages: "/client/messages",
  },
  vendeur: {
    dashboard: "/vendeur/dashboard",
    produits: "/vendeur/produits",
    commandes: "/vendeur/commandes",
    profil: "/vendeur/profil",
    messages: "/vendeur/messages",
  },
  livreur: {
    dashboard: "/livreur/dashboard",
    courses: "/livreur/courses",
    commandes: "/livreur/commandes",
    profil: "/livreur/profil",
    messages: "/livreur/messages",
  },
  admin: {
    dashboard: "/admin/dashboard",
    gestion: "/admin/gestion",
    comptes: "/admin/gestion/comptes",
    catalogue: "/admin/gestion/catalogue",
    commandes: "/admin/gestion/commandes",
    notifications: "/admin/notifications",
    profil: "/admin/profil",
  },
  ambassadeur: {
    dashboard: "/ambassadeur/dashboard",
    ajouter: "/ambassadeur/ajouter",
    reseaux: "/ambassadeur/reseaux",
    comptes: "/ambassadeur/comptes", // legacy alias (kept for backward links)
    profil: "/ambassadeur/profil",
  },
  legal: {
    cguVendeur: "/legal/cgu-vendeur",
    cguLivreur: "/legal/cgu-livreur",
    cguClient: "/legal/cgu-client",
    charteLitiges: "/legal/charte-litiges",
    tableauLitiges: "/legal/tableau-litiges",
    accept: {
      vendeur: "/legal/cgu-vendeur/accept",
      livreur: "/legal/cgu-livreur/accept",
    },
  },
};

export const ROLE_HOME_PATH = {
  client: PATHS.client.home,
  vendeur: PATHS.vendeur.dashboard,
  livreur: PATHS.livreur.dashboard,
  admin: PATHS.admin.dashboard,
  ambassadeur: PATHS.ambassadeur.dashboard,
};

export const PUBLIC_CLIENT_HOME = PATHS.client.home;
export const PUBLIC_VITRINE = PATHS.public.vitrine;

export const isPublicAppPath = (pathname = "") => (
  pathname === PATHS.root ||
  pathname === PUBLIC_CLIENT_HOME ||
  pathname.startsWith("/vitrine/") ||
  pathname.startsWith("/legal/") ||
  pathname === PATHS.authCallback
);

const LEGAL_ACCEPT_BASE = {
  vendeur: PATHS.legal.accept.vendeur,
  livreur: PATHS.legal.accept.livreur,
};

export const getRoleHomePath = (role, fallback = PATHS.root) =>
  ROLE_HOME_PATH[role] || fallback;

export const getPostAuthPath = (userData, fallback = PATHS.root) => {
  const role = userData?.role;
  if (!role) return fallback;

  const acc = userData?.legalAcceptances || {};

  if (role === "vendeur" && !acc?.cguVendeur?.version) {
    const vendeurHome = getRoleHomePath("vendeur", fallback);
    return getLegalAcceptPath("vendeur", vendeurHome) || vendeurHome;
  }

  if (role === "ambassadeur" && !acc?.cguVendeur?.version) {
    const ambassadeurHome = getRoleHomePath("ambassadeur", fallback);
    return getLegalAcceptPath("vendeur", ambassadeurHome) || ambassadeurHome;
  }

  if (role === "livreur" && !acc?.cguLivreur?.version) {
    const livreurHome = getRoleHomePath("livreur", fallback);
    return getLegalAcceptPath("livreur", livreurHome) || livreurHome;
  }

  return getRoleHomePath(role, fallback);
};

export const getLegalAcceptPath = (role, redirect) => {
  const base = LEGAL_ACCEPT_BASE[role];
  if (!base) return null;
  if (!redirect) return base;
  return `${base}?redirect=${encodeURIComponent(redirect)}`;
};

export const sanitizeReturnToPath = (candidate, fallback = PATHS.root) => {
  if (typeof candidate !== "string") return fallback;
  const raw = candidate.trim();
  if (!raw) return fallback;

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    decoded = raw;
  }

  // Prevent open redirects and protocol-relative URLs.
  if (
    decoded.startsWith("http://") ||
    decoded.startsWith("https://") ||
    decoded.startsWith("//") ||
    decoded.startsWith("\\\\")
  ) {
    return fallback;
  }

  if (!decoded.startsWith("/")) return fallback;

  let url;
  try {
    url = new URL(decoded, "https://riveltime.app");
  } catch {
    return fallback;
  }

  const normalized = `${url.pathname}${url.search}${url.hash}`;
  if (!normalized || normalized === PATHS.authCallback) return fallback;
  return normalized;
};
